import { render, staticRenderFns } from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=template&id=4b52b4b2&scoped=true"
import script from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=script&lang=ts"
export * from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=script&lang=ts"
import style0 from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=style&index=0&id=4b52b4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52b4b2",
  null
  
)

export default component.exports